/* tslint:disable */

declare var Object: any;
export interface TtamattlocationServiceInterface {
  "id"?: number;
}

export class TtamattlocationService implements TtamattlocationServiceInterface {
  "id": number;
  constructor(data?: TtamattlocationServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TtamattlocationService`.
   */
  public static getModelName() {
    return "TtamattlocationService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TtamattlocationService for dynamic purposes.
  **/
  public static factory(data: TtamattlocationServiceInterface): TtamattlocationService{
    return new TtamattlocationService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TtamattlocationService',
      plural: 'TtamattlocationServices',
      path: 'TtamattlocationServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/TtamattlocationService.ts